module.exports = __webpack_public_path__ + "img/av.2d08a4f9.svg";